import { useLocalPlayerStore } from '../../stores/localPlayerStore';

// O TEMPO DO PLAYER GLOBAL, em texto, igual na web e no app (31/10/2026).

export const formatarTempo = (s: number): string => {
  if (!isFinite(s) || s < 0) return '0:00';
  const m = Math.floor(s / 60);
  const sec = Math.floor(s % 60);
  return `${m}:${String(sec).padStart(2, '0')}`;
};

/**
 * "0:42 de 3:43" da faixa no player global. Num componente pequeno, só na linha que está no player:
 * o tempo muda várias vezes por segundo, e quem o lê re-renderiza junto.
 */
export const useTempoDoPlayer = (): string => {
  const tempo = useLocalPlayerStore((s) => s.time);
  const duracao = useLocalPlayerStore((s) => s.duration);
  return duracao > 0 ? `${formatarTempo(tempo)} de ${formatarTempo(duracao)}` : formatarTempo(tempo);
};
